import { Component, OnChanges, inject, ChangeDetectionStrategy, input, output } from '@angular/core';
import {MatIcon} from "@angular/material/icon";

import {ReactiveFormsModule} from "@angular/forms";
import {GuruEntity} from "../../../../model/guru-entity";
import {ConfigurationSection, UserStateService} from "../../../../services/user-state.service";
import {ModelService} from "../../../../services/model-service";
import {SelectionUtils} from "../../../selection-utils";

@Component({
    selector: 'app-w2w-sw-res-accessories',
    imports: [
    MatIcon,
    ReactiveFormsModule
],
    templateUrl: './w2w-sw-res-accessories.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrl: './w2w-sw-res-accessories.component.css'
})
export class W2wSwResAccessoriesComponent implements OnChanges {
  private readonly modelService = inject(ModelService);
  private readonly userStateService = inject(UserStateService);


  readonly invalidEntities = input.required<string[]>();
  readonly engineKey = input.required<string>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  readonly valueChanged = output<void>();
  antiScaldValveSelection!: GuruEntity;
  accessoryPumpControlModuleSelection!: GuruEntity;
  compressorSoftStartKitSelection!: GuruEntity;
  extendedWarrantySelection!: GuruEntity;
  smartTankSelection!: GuruEntity;
  isExpanded = true;
  private sectionKey = ConfigurationSection.ACCESSORIES;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.antiScaldValveSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USAntiScaldValve');
    this.accessoryPumpControlModuleSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USPumpControlModule');
    this.compressorSoftStartKitSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSoftStartKit');
    this.extendedWarrantySelection = SelectionUtils.getEntity(this.selectionEntities(), 'USWarranty');
    this.smartTankSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSmartTank');
  }

  selectionChanged(entity: GuruEntity, newValue: string): void {
    entity.Value = newValue;
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.valueChanged.emit());
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  isInvalidSelection(entityName: string) {
    return this.invalidEntities() && this.invalidEntities().indexOf(entityName) >= 0;
  }

}
